import { useEffect, useMemo, useState } from 'react';
import { CompanyMeasurementDateName, FundMeasurementDateName } from 'api';
import FirmsService from 'services/firms';

const useRetrieveDatesForFirm = (firmId: number | null, initialMeasurementDate: (FundMeasurementDateName & CompanyMeasurementDateName) | null) => {
  const [measurementDateNames, setMeasurementDateNames] = useState<Array<FundMeasurementDateName & CompanyMeasurementDateName>>([]);
  const [selectedFundMeasurementDate, setSelectedFundMeasurementDate] = useState<(FundMeasurementDateName & CompanyMeasurementDateName) | null>(null);

  useEffect(() => {
    if (initialMeasurementDate) {
      setSelectedFundMeasurementDate(initialMeasurementDate);
    }
  }, [initialMeasurementDate]);

  useEffect(() => {
    if (firmId) {
      const firmsService = new FirmsService();
      firmsService.getAllMeasurementDatesByFirmIdGroupedByFund(firmId.toString()).then(response => {
        setMeasurementDateNames(response as (FundMeasurementDateName & CompanyMeasurementDateName)[]);
      });
    }
  }, [firmId]);

  const combinedMeasurementDates = useMemo<(FundMeasurementDateName & CompanyMeasurementDateName)[]>(
    () => measurementDateNames.filter(measurementDate => measurementDate.fmd_id || measurementDate.company_id) ?? [],
  [measurementDateNames]
  );

  const uniqueFundMeasurementDatesByDate = useMemo<(FundMeasurementDateName & CompanyMeasurementDateName)[]>(() => {
    const uniqueDates = new Set(combinedMeasurementDates.map(date => date.date));
    return Array.from(uniqueDates)
      .map(date => combinedMeasurementDates.find(d => d.date === date) ?? null)
      .filter((d): d is (FundMeasurementDateName & CompanyMeasurementDateName) => Boolean(d));
  }, [combinedMeasurementDates]);

  return {
    uniqueFundMeasurementDatesByDate,
    combinedMeasurementDates,
    setSelectedFundMeasurementDate,
    selectedFundMeasurementDate,
  };
};

export default useRetrieveDatesForFirm;
